import { useEffect, useMemo, useRef, useState } from 'react'

export const Tooltip = ({
  children,
  text,
  spacingX = 52,
  spacingY = 0,
  disabled = false,
}: {
  children: React.ReactNode
  text: string
  spacingX?: number
  spacingY?: number
  disabled?: boolean
}) => {
  const [isVisible, setIsVisible] = useState(false)
  const [isLeft, setIsLeft] = useState(false)
  const tooltipRef = useRef<HTMLDivElement>(null)
  const id = useMemo(() => `tooltip-${Math.random().toString(36).slice(2, 11)}`, []) // Generate a unique ID for ARIA

  useEffect(() => {
    if (isVisible) {
      setIsLeft(window.innerWidth * 0.5 > (tooltipRef.current?.getBoundingClientRect().x ?? 0))
      if (tooltipRef.current) {
        tooltipRef.current.style.left = `${isLeft ? spacingX : 0}px`
        tooltipRef.current.style.right = `${!isLeft ? spacingX : 0}px`
        tooltipRef.current.style.top = `${spacingY}px`
      }
    }
  }, [isVisible])

  return (
    <div
      className="relative"
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
      onFocus={() => setIsVisible(true)}
      onBlur={() => setIsVisible(false)}
      aria-describedby={isVisible ? id : undefined}>
      {children}
      {isVisible && !disabled && (
        <div
          ref={tooltipRef}
          id={id}
          role="tooltip"
          aria-live="polite"
          className="absolute w-fit rounded-md bg-gray-900 p-2 text-white">
          {text}
        </div>
      )}
    </div>
  )
}
